import { useMediaQuery } from '@mui/material';
import theme from 'providers/theme/theme';
import type { FC } from 'react';
import type { CoverageDetailsProps } from './CoverageDetails.types';
import CoverageDetailsModal from './CoverageDetailsModal/CoverageDetailsModal';
import CoverageDetailsTooltip from './CoverageDetailsTooltip/CoverageDetailsTooltip';

const CoverageDetails: FC<CoverageDetailsProps> = (props) => {
  const isMobileLayout = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobileLayout) return <CoverageDetailsModal {...props} />;

  return <CoverageDetailsTooltip {...props} />;
};

export default CoverageDetails;
